import { Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import BlockIcon from "@mui/icons-material/Block";

export default function WrongMobilePlatform(props: { platform: string }) {
  const { t } = useTranslation();

  return (
    <div>
      <Container>
        <Stack
          display="flex"
          justifyContent="center"
          alignItems="center"
          padding={3}
          spacing={3}
          height="80vh"
          sx={{ maxWidth: 480, margin: "auto", textAlign: "center" }}
        >
          <Typography variant="h3" paragraph>
            {t("Wrong Platform")}
          </Typography>

          <BlockIcon color="error" sx={{ width: 100, height: 100 }} />

          <Typography sx={{ color: "text.secondary" }}>
            {t("This link is intended for ") +
              props.platform +
              (localStorage.getItem("lng") === "it" ? "." : " devices.")}
          </Typography>
        </Stack>
      </Container>
    </div>
  );
}
